export default __webpack_public_path__ + "static/media/enter-ico.ff0e0281.svg";